import { DownloadSimple, FileCsv, FilePdf } from "@phosphor-icons/react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { exportWoCsv, exportWoPdf } from "@/lib/woExport";

export default function WoExportMenu({ parent, sub = null, testid }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    title={sub ? "Export this sub-task" : "Export this work order with all sub-tasks"}
                    className="p-1.5 rounded-md text-fleet-ink hover:bg-slate-100 transition-colors"
                    data-testid={testid}
                >
                    <DownloadSimple size={sub ? 13 : 15} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => exportWoCsv(parent, sub)} data-testid={`${testid}-csv`}>
                    <FileCsv size={14} className="mr-2" /> Export CSV
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => exportWoPdf(parent, sub)} data-testid={`${testid}-pdf`}>
                    <FilePdf size={14} className="mr-2" /> Export PDF
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
